import styled from 'styled-components';

export const ModalWrapper = styled.div`
  padding: 32px;
  width: 500px;

  h2 {
    font-size: 18px;
    font-weight: 400;
    margin: 0 0 36px 0;
    color: #4b4d4e;
  }
`;

export const ModalFooter = styled.div`
  text-align: left;

  > * {
    margin-right: 20px;
  }
`;
